import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { TypeContract } from "../_types/type-contract";

@Injectable({
  providedIn: 'root',
})
export class TypeContractsService extends Service<TypeContract> {
  public override type = 'typeContracts';
  public override url = 'common/typeContracts';
}
